import React from 'react';
import { useQueryId } from '@/hooks';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectLastUpdateMethod } from '@/features/query-builder-steps/queryBuilderStepsSlice';
import { LAST_UPDATE_METHOD } from '@/features/query-builder-steps/constants';
import {
  addToUndoStack,
  selectInitialPathname,
  selectRedoStack,
  selectUndoStack,
} from '../slice';

export const useTrackNavigation = () => {
  const dispatch = useAppDispatch();
  const queryId = useQueryId();
  const initialPathname = useAppSelector(selectInitialPathname);
  const undoStack = useAppSelector(selectUndoStack);
  const redoStack = useAppSelector(selectRedoStack);
  const lastUpdateMethod = useAppSelector(selectLastUpdateMethod);

  const shouldStackQueryId =
    queryId &&
    lastUpdateMethod === LAST_UPDATE_METHOD.stepsSidebarInteraction &&
    initialPathname &&
    !initialPathname.includes(queryId) &&
    !undoStack.includes(queryId) &&
    !redoStack.includes(queryId);

  React.useEffect(() => {
    if (shouldStackQueryId) {
      dispatch(addToUndoStack(queryId));
    }
  }, [queryId, shouldStackQueryId]);
};
